import React from 'react'
import Morden_1 from '../../../assets/images/home_page_3/modern/01.png'
import Morden_2 from '../../../assets/images/home_page_3/modern/02.png'
import { Link } from 'react-router-dom'

const Modren = () => {
    return (
        <>
            <section id="modern-three" className="modern-three-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-lg-12">
                            <div className="section text-center">
                                <div className="section-sub-title">Modern Suite</div>
                                <h4 className="section-title-three">Modern comfort design suite</h4>
                                <p>
                                    When our power of choice is Untrammelled and when nothing prevents
                                    our being able to do what we like best, every pleasure is to be
                                    welcomed and every pain avoided
                                </p>
                                <Link to="#" title="" className="btn btn-primary-three">
                                    Discover More
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-12">
                            <div className="modern-three-img-block">
                                <div className="modern-three-img-one">
                                    <img
                                        src={Morden_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="modern-three-img-two">
                                    <img
                                        src={Morden_2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Modren
